import ReactDOM from "react-dom";
import React from "react";

export default class InjectReactFloatingFilter {
    constructor(cmp) {
        return class {
            constructor() {
                return new ReactWrapper(cmp);
            }

            //dummy for validation
            getGui() { }
            getModelAsString() { }
        };
    }
}

class ReactWrapper {
    parentModel = {}

    constructor(cmp) {
        this.cmp = cmp;
    }

    init(params) {
        this.agGridProps = params;
        this.el = document.createElement("div");
    }

    getGui() {
        return this.el;
    }

    afterGuiAttached() {
        const CMP = this.cmp;

        ReactDOM.render(
            <CMP onChange={this.handleChange} {...this.agGridProps} />,
            this.el
        );
    }

    onParentModelChanged(parentModel) {
        this.parentModel = parentModel;
    }

    // getModelAsString() {
    //     return "";
    // }

    // getModel() {
    //     return (
    //         this.value
    //         // ??
    //         // this.cmp.prototype.getDefaultValue?.(this.agGridProps) ??
    //         // this.agGridProps.value
    //     );
    // }

    // setModel() {

    // }

    // isPopup() {
    //     return this.cmp.prototype.isPopup?.() ?? false;
    // }

    handleChange = (value) => {
        this.value = value;
        this.agGridProps.parentFilterInstance((instance) => {
            instance.onFloatingFilterChanged(value);
        });
    };

    destroy() {
        ReactDOM.unmountComponentAtNode(this.el);
    }
}
